import React, { useEffect, useRef, useState } from "react";
import "./ContactForm.scss";
import { useForm, ValidationError } from "@formspree/react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ContactForm() {
  const FORM_ID = "xoveqlly";

  const [state, handleSubmit] = useForm(FORM_ID);

  // Reference to the form
  const formRef = useRef(null);

  // Controls success message visibility
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const addresses = [
    {
      country: "India",
      address:
        "Z1-3090, Akshar Business Park, Turbhe Vashi, Navi Mumbai 400703, Maharashtra, India.",
    },
    {
      country: "Egypt",
      address:
        "91438 Building No.19, Mohamed Fathy Street, Kornich El Nile, Dar Al Salam, Cairo, Egypt",
    },
    {
      country: "China",
      address:
        "301-391, 3rd Floor, No.123, Dongtong South Road, Liwan District, Guangzhou, China.",
    },
    {
      country: "Hong Kong",
      address:
        "Rooms 1318-20, Hollywood Plaza, 610 Nathan Road, Mongkok, KL, Hong Kong",
    },
    {
      country: "South Korea",
      address:
        "188 Keunsam-ri, Paekam-myeon, Cheoin-gu, Youngin-City, Kyongki-do, Korea",
    },
  ];

  // After successful submission
  useEffect(() => {
    if (!state.succeeded) {
      return;
    }

    // Clear all form fields automatically
    if (formRef.current) {
      formRef.current.reset();
    }

    // Show success message
    setShowSuccessMessage(true);

    // Show success toast
    toast.success(
      "Your form has been submitted! We will get back to you shortly.",
      {
        position: "top-center",
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
      }
    );

    // Hide success message after 5 seconds
    const timer = setTimeout(() => {
      setShowSuccessMessage(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, [state.succeeded]);

  return (
    <section className="contact-section section-padding" id="section_6">
      <div className="container">
        {/* Contact Info + Form */}
        <div className="row">
          <div className="col-lg-4 col-12 ms-auto mb-5 mb-lg-0">
            {/* Contact Info */}
            <div className="contact-info-wrap">
              <h2 className="heading-2-contact">Get in touch</h2>

              {/* Founder Section */}
              {/*
              <div className="contact-image-wrap d-flex flex-wrap">
                <img
                  src="./assets/img/founder.avif"
                  className="img-fluid avatar-image"
                  alt="Shabuddin Choudhary"
                />
                <div className="d-flex flex-column justify-content-center ms-3">
                  <p className="mb-0">Shabuddin Choudhary</p>
                  <p className="mb-0">
                    <strong>CEO</strong>
                  </p>
                </div>
              </div>
              */}

              <div className="contact-info">
                <h5 className="mb-3">Contact Information</h5>

                <p className="d-flex mb-2">
                  <i className="bi bi-geo-alt me-2"></i>
                  Z1-3090, Akshar Business Park, Turbhe Vashi, Navi Mumbai
                  400703, Maharashtra, India.
                </p>

                <p className="d-flex mb-2">
                  <i className="bi bi-telephone me-2"></i>
                  <a href="tel:+919964990777">+919964990777</a>
                </p>

                <p className="d-flex">
                  <i className="bi bi-envelope me-2"></i>
                  <a href="mailto:info@dohrniiexim.com">
                    info@dohrniiexim.com
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="col-lg-5 col-12 mx-auto">
            <form
              ref={formRef}
              className="fs-form custom-form contact-form"
              onSubmit={handleSubmit}
            >
              <h2 className="heading-2-contact">Contact Form</h2>

              <p className="mb-4">
                Or, you can just send an email:{" "}
                <a href="mailto:info@dohrniiexim.com">
                  info@dohrniiexim.com
                </a>
              </p>

              {/* First Name + Last Name */}
              <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                  <input
                    type="text"
                    name="first-name"
                    className="form-control"
                    placeholder="First Name"
                    autoComplete="given-name"
                    required
                  />
                </div>

                <div className="col-lg-6 col-md-6 col-12">
                  <input
                    type="text"
                    name="last-name"
                    className="form-control"
                    placeholder="Last Name"
                    autoComplete="family-name"
                    required
                  />
                </div>
              </div>

              {/* Email */}
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Enter your email"
                autoComplete="email"
                required
              />

              <ValidationError
                prefix="Email"
                field="email"
                errors={state.errors}
              />

              {/* Message */}
              <textarea
                name="message"
                rows="5"
                className="form-control"
                placeholder="What can we help you with?"
                required
              ></textarea>

              <ValidationError
                prefix="Message"
                field="message"
                errors={state.errors}
              />

              {/* Formspree Error */}
              {state.errors && state.errors.length > 0 && (
                <div className="form-error-message">
                  <p>
                    Unable to submit the form. Please check your details and
                    try again.
                  </p>
                </div>
              )}

              <p className="fs-description">
                We usually respond within 1-2 business days.
              </p>

              {/* Submit Button */}
              <button
                type="submit"
                className="form-control submit-button"
                disabled={state.submitting}
              >
                {state.submitting ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>

        {/* Global Presence */}
        <div className="global-presence mb-5 mt-5">
          <h2 className="heading-2-contact text-center mb-4">
            Our Global Presence
          </h2>

          {/* Global Map */}
          {/*
          <div className="text-center mb-4">
            <img
              src="./assets/img/global-map.png"
              className="img-fluid"
              alt="Global presence"
            />
          </div>
          */}

          <div className="addresses d-flex flex-wrap justify-content-center text-center">
            {addresses.map((item, index) => (
              <div key={index} className="address-card">
                <h5>{item.country}</h5>
                <p>{item.address}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Success Message */}
        {showSuccessMessage && (
          <div className="success-message" role="alert">
            <p>
              Your form has been submitted! We will get back to you shortly.
            </p>
          </div>
        )}
      </div>

      {/* Toast Notification */}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </section>
  );
}